import React, { useEffect, useState } from "react";
import { Tag } from "../../../../../design-system";
import mediaOps, { isTerminalJob, JobSummary } from "../../../../../database/mediaOps/mediaOpsApi";
import { jobChip } from "./stateLabels";
import { ErrorLine, Mono, Row, Small, usd } from "./ui";

export const JOB_POLL_MS = 4000;

/** Polls get_media_job every 4s while queued or running. Stops on a terminal state. */
export const JobProgress: React.FC<{ communityId: string; jobId: string; onTerminal?: (job: JobSummary) => void }> = ({
  communityId,
  jobId,
  onTerminal,
}) => {
  const [job, setJob] = useState<JobSummary | null>(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    let alive = true;
    let timer: ReturnType<typeof setTimeout> | null = null;
    const tick = async () => {
      const r = await mediaOps.getJob(communityId, jobId);
      if (!alive) return;
      if (r.status === "blocked") {
        setErr(r.errors.map((e) => `${e.code}: ${e.message}`).join(" "));
        if (r.transportError) timer = setTimeout(tick, JOB_POLL_MS);
        return;
      }
      setErr("");
      const j = (r.data as any)?.job || r.data;
      setJob(j);
      if (isTerminalJob(j?.status)) {
        onTerminal?.(j);
        return;
      }
      timer = setTimeout(tick, JOB_POLL_MS);
    };
    tick();
    return () => {
      alive = false;
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [communityId, jobId]);

  if (err && !job) return <Small>{err}</Small>;
  if (!job) return <Small>Loading job {jobId}.</Small>;
  const chip = jobChip(job.status);
  return (
    <div>
      <Row>
        <Tag size="sm" variant={chip.variant}>
          {chip.label}
        </Tag>
        <Small>
          Stage {job.stage || "none"}, {Math.round((job.progress || 0) * (job.progress <= 1 ? 100 : 1))}%
        </Small>
        <Small>
          Reserved {usd(job.budget?.reservedUsd)}, actual {usd(job.budget?.actualUsd)}
        </Small>
        <Mono>{job.jobId || jobId}</Mono>
      </Row>
      {job.error ? <ErrorLine error={job.error} /> : null}
      {job.resultRevisionId ? <Small>Result revision {job.resultRevisionId}.</Small> : null}
      {err ? <Small>{err}</Small> : null}
    </div>
  );
};

export default JobProgress;
